import { useEffect, useRef } from 'react';
import { useReducedMotion } from 'framer-motion';

export default function VideoOverlay({ src, poster, tint = 'hero', className = '' }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();

  useEffect(() => {
    const v = ref.current;
    if (!v) return undefined;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (reduce) return;
        if (entry.isIntersecting) v.play().catch(() => {});
        else v.pause();
      },
      { threshold: 0.15 }
    );
    io.observe(v);
    return () => io.disconnect();
  }, [reduce]);

  if (reduce) {
    return (
      <div className={`video-holder ${className}`} aria-hidden="true">
        <img src={poster} alt="" loading="lazy" />
        <div className={`video-tint video-tint--${tint}`} />
      </div>
    );
  }

  return (
    <div className={`video-holder ${className}`} aria-hidden="true">
      <video ref={ref} src={src} poster={poster} muted loop autoPlay playsInline preload="metadata" />
      <div className={`video-tint video-tint--${tint}`} />
    </div>
  );
}
